import { calculateBiddingModel } from "../../visitor-checks/calculateBiddingModel";
import { calculateLeadScore } from "../../visitor-checks/calculateLeadScore";
import { getVisitorStatusCode } from "../../visitor-checks/getVisitorStatusCode";
import { stepsNames } from "../config.const";
import type { SubPractices } from "../config.types";

import { hasCompletedIntakeQuestionnaire } from "./common-family";

export const familyAlimony: SubPractices = {
  firstScreen: "service-type",
  screens: {
    "service-type": {
      next: async () => "zip-code",
    },
    "zip-code": {
      next: async ({ answers, meta }) => {
        const { state } = answers;
        const { skip } = meta;

        if (skip) {
          return "state-selection";
        }

        if (state === "unsupported") {
          return "unsupported";
        }

        return "location-confirmation";
      },
    },
    "state-selection": {
      next: async ({ answers }) => {
        const { state } = answers;

        if (state === "unsupported") {
          return "unsupported";
        }

        return "location-confirmation";
      },
    },
    unsupported: {
      next: async () => "unsupported-confirmed",
      sanitize: true,
    },
    "unsupported-confirmed": {
      next: async () => "unsupported-confirmed",
    },
    "location-confirmation": {
      next: async () => "case-urgency",
    },
    "case-urgency": {
      next: async () => "more-info",
    },
    "more-info": {
      next: async ({ answers }) => {
        await calculateLeadScore({ answers, step: stepsNames["more-info"] });
        await calculateBiddingModel({
          answers,
          step: stepsNames["more-info"],
        });
        return "create-meeting";
      },
    },
    "create-meeting": {
      next: async () => "contact-info",
    },
    "contact-info": {
      next: async ({ answers }) => {
        await calculateBiddingModel({
          answers,
          step: "contact-info",
        });

        return "intake-confirmation";
      },
      isAuth: true,
      sanitize: true,
    },
    "intake-confirmation": {
      next: async () => undefined,
    },
    "out-of-scope": {
      next: async () => undefined,
    },
    "attorney-qualities": {
      next: async ({ answers }) => {
        if (answers?.leadSource === "legal-plan") {
          return "opposing-party";
        }
      },
    },
    "opposing-party": {
      next: async ({ answers }) => {
        if (
          answers.leadSource === "legal-plan" ||
          hasCompletedIntakeQuestionnaire()
        ) {
          const statusCode = await getVisitorStatusCode({
            answers,
            currentStep: stepsNames["opposing-party"],
          });

          if (statusCode) {
            answers.visitorStatusCode = statusCode;
            if (statusCode !== "ELG1" && statusCode !== "ERROR") {
              return "out-of-scope";
            }
          }
          return "book-lss";
        }
      },
      isUpdate: true,
    },
    // Direct LSS steps
    "book-lss": {
      next: async () => {
        /*
        This step is used for:
         - Legal plan leads
         - Pre-clients with completed intake questionnaires 
        */
        return "lss-checkout";
      },
    },
    "lss-checkout": {
      next: async ({ meta }) => {
        const { checkoutStatus } = meta;
        return checkoutStatus;
      },
      isUpdate: true,
    },
    "slot-is-taken": {
      next: async () => "book-lss",
    },
    "payment-declined": {
      next: async () => "lss-checkout",
    },
    "lss-confirmation": {
      next: async () => undefined,
    },
  },
};
